function BuildReqHeaders(token) {
	return {
		authorization: `Bearer ${token}`,
	};
}

export default BuildReqHeaders;
